import dayjs from "./dayjs";

const ARABIC_DIGITS = /[٠-٩]/g;
const PERSIAN_DIGITS = /[۰-۹]/g;
const ARABIC_MAP = {
  "٠": "0",
  "١": "1",
  "٢": "2",
  "٣": "3",
  "٤": "4",
  "٥": "5",
  "٦": "6",
  "٧": "7",
  "٨": "8",
  "٩": "9"
};
const PERSIAN_MAP = {
  "۰": "0",
  "۱": "1",
  "۲": "2",
  "۳": "3",
  "۴": "4",
  "۵": "5",
  "۶": "6",
  "۷": "7",
  "۸": "8",
  "۹": "9"
};

export function toEnglishDigits(value) {
  if (value === null || value === undefined) return "";
  return String(value)
    .replace(ARABIC_DIGITS, (d) => ARABIC_MAP[d] || d)
    .replace(PERSIAN_DIGITS, (d) => PERSIAN_MAP[d] || d);
}

export function toNumber(value) {
  const normalized = toEnglishDigits(value).replace(/,/g, "").trim();
  const num = Number(normalized);
  return Number.isFinite(num) ? num : 0;
}

export function formatMoney(value) {
  const safe = toNumber(value);
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(safe);
}

export function formatMoneyWithUnit(value) {
  return `${formatMoney(value)} IQD`;
}

export function formatDate(value) {
  if (!value) return "—";
  return toEnglishDigits(dayjs(value).format("YYYY/MM/DD"));
}

export function formatDateTime(date, time) {
  if (!date) return "—";
  const safeTime = time ? toEnglishDigits(time) : "";
  return `${formatDate(date)}${safeTime ? ` - ${safeTime}` : ""}`;
}
